<template>
  <hxm-popup
      :show="isShow"
      position="bottom"
      :round="true"
      height="86%"
      @overlay-click="handleOverlayClick">
    <div class="popup-content-box">
      <div class="title-box">
        <span class="popup-title text-primary">{{title}}</span>
        <div class="close-icon-box" @click="handleClose">
          <img src="../images/close.png" alt="">
        </div>
      </div>
      <div class="item-box">
        <slot></slot>
      </div>
    </div>
  </hxm-popup>
</template>

<script>
export default {
  name: "CustomPopup",
  props: {
    isShow: {
      type: Boolean
    },
    title: {
      type: String,
      default: '弹窗标题'
    }
  },
  methods: {
    /** 点击遮罩层 */
    handleOverlayClick() {
      this.$emit('overlay-click')
    },

    /** 处理关闭 */
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
.popup-content-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 9;

  .title-box {
    width: 100%;
    height: 1.3rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 0.32rem;
    position: relative;

    .popup-title {
      font-size: .36rem;
      font-family: PingFangSC-Medium;
      letter-spacing: 0;
      font-weight: 500;
    }

    .close-icon-box {
      position: absolute;
      top: 0.48rem;
      right: 0.32rem;
      width: 0.48rem;
      height: 0.48rem;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 0.3rem;
        height: 0.3rem;
      }
    }
  }

  .item-box {
    height: 90%;
    width: 100%;
    overflow-y: scroll;
  }
}
</style>
